<template>
  <div class="">
    <!--<el-row>-->
    <el-row style="padding: 20px 0">
      <h3>Samco 34</h3>
    </el-row>
    <el-row style="padding-top: 20px">
    <div class="" v-drag-and-drop:options="options">

      <el-col :offset="1" :span="15" class="map-content">
        <el-row style="padding-bottom: 25px">
          <span style="font-size: 25px; font-weight: bold">{{ $t('common.rear') }}</span>
        </el-row>
        <div v-for="(row, indexRow) in listSeat" :key="indexRow">
          <el-row>
            <div v-for="(seat, indexSeat) in row" :key="indexSeat">
              <div v-if="indexRow == 6 && (indexSeat == 0)" v-bind:class="{marginRight : indexSeat==1}"
                   class="slot-bus">
                <div class="drop" style="background-color: azure">
                  <el-row>
                    <div class="student-name" style="font-size: 20px; font-weight: bold">
                      {{ $t('common.door') }}
                    </div>
                  </el-row>
                </div>
              </div>
              <div v-else-if="indexRow == 6 && (indexSeat == 1)" v-bind:class="{marginRight : indexSeat==1}"
                   class="slot-bus">
                <div class="drop" style="background-color: floralwhite; height: 99%">
                  <el-row>
                    {{ $t('common.not_allowed') }}
                  </el-row>
                </div>
              </div>
              <div v-else v-bind:class="{marginRight : indexSeat==1}" class="slot-bus">
                <div v-bind:class="{ selectedBackground: seat.fullname }" class="drop seat-drop" @added="added" :data-seat="indexSeat" :data-row="indexRow">
                  <template v-if="!seat.fullname">
                    <div>{{ $t('common.available') }}</div>
                  </template>
                  <template v-else>
                    <div class="student-name">
                      <div>{{ seat.fullname }}</div>
                      <div>{{ seat.furigana }}</div>
                      <div v-if="seat.class_info">
                        {{ seat.class_info.class_name }}
                      </div>
                    </div>
                  </template>
                  <el-button v-show="seat.id" @click="removeStudent(indexRow, indexSeat)"
                     class="setting-seat-remove-btn" type="danger" icon="el-icon-minus">
                  </el-button>
                </div>
              </div>
            </div>
          </el-row>
        </div>
        <el-row>
          <div class="slot-bus">
            <div class="drop" style="background-color: floralwhite; height: 99%">
              <el-row>
                {{ $t('common.not_allowed') }}
              </el-row>
            </div>
          </div>
          <div class="slot-bus marginRight">
            <div class="drop" style="background-color: floralwhite; height: 99%">
              <el-row>
                {{ $t('common.not_allowed') }}
              </el-row>
            </div>
          </div>
          <div class="slot-bus">
            <div class="drop" style="background-color: floralwhite; height: 99%">
              <el-row>
                {{ $t('common.not_allowed') }}
              </el-row>
            </div>
          </div>
          <div class="slot-bus">
            <div class="drop" style="background-color: azure">
              <el-row>
                  <div class="student-name" style="font-size: 20px; font-weight: bold">
                    {{ $t('common.driver') }}
                  </div>
              </el-row>
            </div>
          </div>
        </el-row>
        <el-row style="padding-top: 25px">
          <span style="font-size: 25px; font-weight: bold">{{ $t('common.front') }}</span>
        </el-row>
      </el-col>

      <el-col :offset="1" :span="7">
        <el-row style="padding-bottom: 25px">
          <span style="font-size: 25px; font-weight: bold">{{ $t('common.student') }}</span>
        </el-row>
        <div class="student-list">
          <div class="slot-student" v-for="(student, index) in studentList" :key="index" :data-id="student.id">
            <div class="drag">
              <el-row>
                <div class="student-name">
                  <template v-if="!student.fullname">
                    <div>{{ $t('common.available') }}</div>
                  </template>
                  <template v-else>
                    <div>{{ student.fullname }}</div>
                    <div>{{ student.furigana }}</div>
                    <div v-if="student.class_info">{{ student.class_info.name }}</div>
                  </template>
                </div>
              </el-row>
            </div>
          </div>
        </div>
      </el-col>
    </div>
    </el-row>
    <el-row style="padding: 50px 0">
      <el-button style="font-size: 20px; width: 30%" type="success" @click="saveAction">{{ $t('common.save') }}
      </el-button>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "Samco34",
    components: {},
    props: {
      studentList: {
        type: Array,
        required: true
      },
      type: {
        type: String,
        required: true
      },
      listSeatGet: {
        type: Array,
        required: true
      }
    },
    data: function () {
      return {
        draggable: this.$t('common.drag'),
        currentSelect: null,
        currentStudentIndex: null,
        listSeat: [
          [
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
          ], [
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
          ],
          [
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
          ],
          [
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
          ],
          [
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
          ],
          [
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
          ],
          [
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
          ],
          [
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
            {id: "", fullname: "", class_info: {class_id: "", class_name: ""}},
          ],
        ],
        options: {
          dropzoneSelector: '.seat-drop',
          draggableSelector: '.slot-student',
          handlerSelector: null,
          reactivityEnabled: true,
          multipleDropzonesItemsDraggingEnabled: true,
          showDropzoneAreas: true,
          onDrop: function(event) {},
          onDragstart: function (event) {
            let item = event.items[0]

            if (item && !item.dataset && item.attributes) {
              let dataset = {}
              let pattern = /^data-/g

              for (let index in item.attributes) {
                let attribute = item.attributes[index]

                if (pattern.test(attribute.name)) {
                  let field = attribute.name.replace('data-', '')
                  dataset[field] = attribute.nodeValue
                }
              }

              item.dataset = dataset
            }
          },
          onDragend: function(event) {

          }
        }
      };
    },
    methods: {
      added (event) {
        let target = event.target

        if (target && !target.dataset && target.attributes) {
          let dataset = {}

          for (let index in target.attributes) {
            let pattern = /^data-/g
            let attribute = target.attributes[index]

            if (pattern.test(attribute.name)) {
              let field = attribute.name.replace('data-', '')
              dataset[field] = attribute.nodeValue
            }
          }

          target.dataset = dataset
        }

        let studentId = parseInt(event.detail.ids[0])

        if (studentId) {
          let rowIndex = target.dataset.row
          let seatIndex = target.dataset.seat

          if (!this.listSeat[rowIndex][seatIndex].id) {
            this.studentList.forEach((item, index) => {
              if (item.id === studentId) {
                this.listSeat[rowIndex][seatIndex].id = item.id
                this.listSeat[rowIndex][seatIndex].fullname = item.fullname
                this.listSeat[rowIndex][seatIndex].furigana = item.furigana
                if (item.class_info) {
                  this.listSeat[rowIndex][seatIndex].class_info = {
                    class_name: item.class_info.name,
                    class_id: item.class_info.id
                  }
                }

                this.studentList.splice(index, 1)
              }
            })
          }
        }
      },
      removeStudent(indexRow, indexSeat) {
        let selectedStudent = this.listSeat[indexRow][indexSeat]
        let student = {
          id: selectedStudent.id,
          fullname: selectedStudent.fullname,
          furigana: selectedStudent.furigana,
          class_info: {
            id: selectedStudent.class_info.class_id,
            name: selectedStudent.class_info.class_name
          }
        }
        selectedStudent.id = ""
        selectedStudent.fullname = ""
        selectedStudent.furigana = ""
        selectedStudent.class_info.class_name = ""
        selectedStudent.class_info.class_id = ""

        this.studentList.push(student)
      },
      saveAction: function () {
        var data = {
          list_seat : this.listSeat,
        }
        this.$emit('saveSeatAction', data)
      }
    },
    mounted: function () {
      if (this.listSeatGet.length) {
        this.listSeat = [].concat(this.listSeatGet)
      }
    }
  }

</script>

<style lang="scss">


</style>
